import type { JSX, ReactNode } from 'react';
import { type LucideIcon } from 'lucide-react';

type Alignment = 'left' | 'center' | 'right';

interface CardProps {
  /** Lucide icon component */
  icon?: LucideIcon;
  /** Card title */
  title: string;
  /** Title alignment */
  titleAlign?: Alignment;
  /** Content alignment */
  contentAlign?: Alignment;
  /** Content text (used if no children provided) */
  content?: string;
  /** Enable hover glow effect */
  hoverable?: boolean;
  /** Card children (takes priority over content prop) */
  children?: ReactNode;
}

export const Card = ({
  icon: Icon,
  title,
  titleAlign = 'center',
  contentAlign = 'center',
  content,
  hoverable = false,
  children,
}: CardProps): JSX.Element => {
  const alignClass: Record<Alignment, string> = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right',
  };

  return (
    <div className={`feature-card ${hoverable ? 'feature-card-hoverable' : ''}`}>
      {Icon && (
        <div className='feature-card-icon'>
          <Icon size={48} strokeWidth={1.5} />
        </div>
      )}
      <h3 className={`feature-card-title ${alignClass[titleAlign]}`}>{title}</h3>
      <div className={`feature-card-content ${alignClass[contentAlign]}`}>{children ?? content}</div>
    </div>
  );
};
